import * as React from "react"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import SiteSearch from "./SiteSearch"

export default class SiteSearchPage extends React.PureComponent {
  render() {
    return <AppPageWrapper parentClassName={"align-items-center"} showNav>
      <SiteSearch />
    </AppPageWrapper>
  }
}
